<template>
  <table class="table child-table " :class="getClass" >

    <tr>
      <th :width="columnWidth.firstColumn">{{ $t('jobs.table.orderNumber') }}r</th>
      <th>{{ $t('workflows.name') }}</th>
      <th>{{ $t('conditionMonitoring.productionStart') }}</th>
      <th>{{ $t('conditionMonitoring.productionEnd') }}</th>
      <th>PPH Plan</th>
      <th>PPH Actual</th>
      <th :width="columnWidth.minkva">{{ $t('conditionMonitoring.math.min') }}kVA</th>
      <th :width="columnWidth.maxkva">{{ $t('conditionMonitoring.math.max') }}kVA</th>
      <th :width="columnWidth.avgkva">{{ $t('conditionMonitoring.math.avg') }} kVA</th>
      <th :width="columnWidth.kvahPerKg">{{ $t('conditionMonitoring.power.kvaKg') }}</th>
      <th :width="columnWidth.powerFactor">{{ $t('conditionMonitoring.power.powerFactor') }}</th>
    </tr>
     <tr :key="'child'+uid+idx" v-for="(run,idx) in row.productionRuns" class=child-table-row :class="getClass ">
      <td>{{ run.additionalData.orderNumber ? run.additionalData.orderNumber : run.uid }}</td>
      <td>{{ run.workflow }}</td>
      <td>{{ formatDate(run.productionStart) }}</td>
      <td>{{ run.productionEnd ? formatDate(run.productionEnd) : '-'  }}</td>
      <td>{{ formatNumber(run.pph) }}</td>
      <td>{{ formatNumber(run.pphActual) }}</td>
      <td>{{ formatNumber(round(run.kva.min, 2)) }} {{   $t('conditionMonitoring.power.kva')}}</td>
      <td>{{ formatNumber(round(run.kva.max, 2)) }} {{   $t('conditionMonitoring.power.kva')}}</td>
      <td>{{ formatNumber(round(run.kva.avg, 2)) }} {{   $t('conditionMonitoring.power.kva')}}</td>

      <td> {{ formatNumber(round(run.kvahPerKg, 2)) }} {{   $t('conditionMonitoring.power.kvaKg')}}</td>

      <td>{{ formatNumber(round(run.powerFactor.avg, 2)) }}</td>

    </tr>
  </table>

</template>

<script>
import { formatNumber, round } from '@/filters/filters';

export default {
  name: "ChildTable",
  props: {
    row: Object,
    index:Number,
    columnWidth:Object,
  },
  data() {
    return {
      uid: this._uid
    }
  },
  computed:{
    getClass(){
      return ' striped'
     }
  },
  methods:{
    formatNumber,
    round,
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm')
    }
  },
  created() {
   }
}
</script>

<style scoped lang="scss">
$striped:#F1F3F5;
.table{
  margin-bottom: 0rem
}
 .striped{
   background:$striped;
 }
 .unstriped{
   background:white;
 }
</style>